import { render } from "./NewProductCard.vue?vue&type=template&id=5afe551b&scoped=true"
import script from "./NewProductCard.vue?vue&type=script&lang=js"
export * from "./NewProductCard.vue?vue&type=script&lang=js"

import "./NewProductCard.vue?vue&type=style&index=0&id=5afe551b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afe551b"]])

export default __exports__